import { render, staticRenderFns } from "./DialogAddNivelIncendio.vue?vue&type=template&id=5c0ecd34&scoped=true"
import script from "./DialogAddNivelIncendio.vue?vue&type=script&lang=js"
export * from "./DialogAddNivelIncendio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ecd34",
  null
  
)

export default component.exports